export default __webpack_public_path__ + "static/media/icon5.bd354ed8.png";